import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { shareReplay, from, map, catchError, of } from 'rxjs';
import { io } from 'socket.io-client';

class AddressService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        //https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome
        this.states = [{ "id": 12, "sigla": "AC", "nome": "Acre", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 27, "sigla": "AL", "nome": "Alagoas", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 16, "sigla": "AP", "nome": "Amapá", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 13, "sigla": "AM", "nome": "Amazonas", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 29, "sigla": "BA", "nome": "Bahia", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 23, "sigla": "CE", "nome": "Ceará", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 53, "sigla": "DF", "nome": "Distrito Federal", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 32, "sigla": "ES", "nome": "Espírito Santo", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 52, "sigla": "GO", "nome": "Goiás", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 21, "sigla": "MA", "nome": "Maranhão", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 51, "sigla": "MT", "nome": "Mato Grosso", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 50, "sigla": "MS", "nome": "Mato Grosso do Sul", "regiao": { "id": 5, "sigla": "CO", "nome": "Centro-Oeste" } }, { "id": 31, "sigla": "MG", "nome": "Minas Gerais", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 15, "sigla": "PA", "nome": "Pará", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 25, "sigla": "PB", "nome": "Paraíba", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 41, "sigla": "PR", "nome": "Paraná", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 26, "sigla": "PE", "nome": "Pernambuco", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 22, "sigla": "PI", "nome": "Piauí", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 33, "sigla": "RJ", "nome": "Rio de Janeiro", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 24, "sigla": "RN", "nome": "Rio Grande do Norte", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 43, "sigla": "RS", "nome": "Rio Grande do Sul", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 11, "sigla": "RO", "nome": "Rondônia", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 14, "sigla": "RR", "nome": "Roraima", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }, { "id": 42, "sigla": "SC", "nome": "Santa Catarina", "regiao": { "id": 4, "sigla": "S", "nome": "Sul" } }, { "id": 35, "sigla": "SP", "nome": "São Paulo", "regiao": { "id": 3, "sigla": "SE", "nome": "Sudeste" } }, { "id": 28, "sigla": "SE", "nome": "Sergipe", "regiao": { "id": 2, "sigla": "NE", "nome": "Nordeste" } }, { "id": 17, "sigla": "TO", "nome": "Tocantins", "regiao": { "id": 1, "sigla": "N", "nome": "Norte" } }];
    }
    getAddressByCep(cep) {
        return this.httpClient.get(`https://viacep.com.br/ws/${cep}/json/`);
    }
    getStates() {
        return this.states;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class MapsService {
    constructor() {
        this.apiKey = 'AIzaSyBFCVmUZjyExOpR2q_6m1-knXmArPT2-9k';
        this.mapsApiUrl = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
        this.apiLoaded$ = this.loadGoogleMapsApi().pipe(shareReplay(1));
    }
    getApiStatus() {
        return this.apiLoaded$;
    }
    loadGoogleMapsApi() {
        return from(new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${this.mapsApiUrl}"]`)) {
                resolve(true);
                return;
            }
            const script = document.createElement('script');
            script.src = this.mapsApiUrl;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(true);
            script.onerror = () => reject(false);
            document.body.appendChild(script);
        })).pipe(map(() => true), catchError(() => of(false)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class TaskListService {
    constructor(handler) {
        this.handler = handler;
        this.httpClient = new HttpClient(handler);
    }
    completeTask(host, token, taskId, form) {
        return this.httpClient.post(`${host}/workflow-api/api/process-flow-task/complete/${taskId}`, {
            form,
            variables: []
        }, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getAllTasks(host, token, rsql = '', page = 0, size = 10, sort = 'createdAt,desc') {
        return this.httpClient.get(`${host}/workflow-api/api/process-flow-task/all?search=${rsql}&page=${page}&size=${size}&sort=${sort}`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getTasks(host, token, rsql = '', page = 0, size = 10, sort = 'createdAt,desc') {
        return this.httpClient.get(`${host}/workflow-api/api/process-flow-task?search=${rsql}&page=${page}&size=${size}&sort=${sort}`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getUserTasksByProcessId(host, token, processId) {
        return this.httpClient.get(`${host}/workflow-api/api/process-flow-task/users-by-process-ids?processIds=${processId}&reversed=true`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getProcess(host, token, rsql = '', page = 0, size = 10, sort = 'createdAt,desc') {
        return this.httpClient.get(`${host}/workflow-api/api/process-flow?search=${rsql}&page=${page}&size=${size}&sort=${sort}`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getTaskTypes(host, token) {
        return this.httpClient.get(`${host}/workflow-api/api/process-flow-task/types`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getProcessTypes(host, token) {
        return this.httpClient.get(`${host}/workflow-api/api/process/types`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    claimOwner(host, token, taskId) {
        return this.httpClient.put(`${host}/workflow-api/api/process-flow-task/owner/${taskId}`, {}, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getLoggedUserId(host, token) {
        return this.httpClient.get(`${host}/workflow-api/api/usuarios/logged-user-id`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    getFlowTaskSectors(host, token) {
        return this.httpClient.get(`${host}/workflow-api/api/sectors`, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    unclaimOwner(host, token, taskId) {
        return this.httpClient.put(`${host}/workflow-api/api/process-flow-task/undo-owner/${taskId}`, {}, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
        });
    }
    isWorkflowEnabled(host) {
        return this.httpClient.get(`${host}/workflow-api/actuator/active`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaskListService, deps: [{ token: i1.HttpBackend }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaskListService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaskListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpBackend }] });

class WebsocketService {
    constructor() {
        this.ioFunction = io;
    }
    static { this.socketInstance = null; }
    getInstance(host) {
        if (host == '.' || host == '') {
            host = window.location.origin;
        }
        if (!WebsocketService.socketInstance) {
            WebsocketService.socketInstance = this.ioFunction(host?.replace('https://', ''), {
                path: '/socket_api_socket',
                transports: ['websocket'],
                auth: { 'id': '1511ae76' }
            });
        }
        return WebsocketService.socketInstance;
    }
    static getTenant() {
        const windowRef = WebsocketService.getWindow();
        const hostname = windowRef.location.hostname;
        return hostname.substr(0, hostname.includes('.') ? hostname.indexOf('.') : hostname.length);
    }
    static getWindow() {
        return window;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WebsocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ScriptLoaderService {
    constructor() {
        this.loadedScripts = {};
    }
    loadScript(src) {
        return from(new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                resolve(true);
                return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(true);
            script.onerror = () => reject(false);
            document.body.appendChild(script);
        })).pipe(map(() => true), catchError(() => of(false)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ScriptLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ScriptLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ScriptLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

/**
 * Generated bundle index. Do not edit.
 */

export { AddressService, MapsService, ScriptLoaderService, TaskListService, WebsocketService };
